import { gql, gqlFetch } from '@/service/gql'
import type { ResultOf } from 'gql.tada'
import type { SanitizedGql } from '@/util/gqlUtil'
import { getAuth } from '@/auth/authRef'
import { trackFieldsFrag } from '@/track/trackFieldsFrag'

/**
 * Most-recently-added tracks in the user's library. Mirrors hornet's
 * "Recently Added" widget. The connection accepts `sortBy`; we ask for
 * the saved-date-descending order so the latest additions land first.
 */
const recentlyAddedTracksQuery = gql(
    `
  query recentlyAddedTracks($limit: Float!, $isAuthenticated: Boolean!) {
    user {
      id
      libraryTracks(limit: $limit, sortBy: "LIBRARY_DATE_DESC") {
        edges {
          node { ...trackFields }
        }
      }
    }
  }
`,
    [trackFieldsFrag]
)

export type RecentlyAddedTracksResult = SanitizedGql<ResultOf<typeof recentlyAddedTracksQuery>>

export async function fetchRecentlyAddedTracks(limit = 100): Promise<RecentlyAddedTracksResult> {
    return gqlFetch(
        recentlyAddedTracksQuery,
        { limit, isAuthenticated: getAuth().isSignedIn() },
        { cache: true, isRetryableError: () => true }
    )
}
